<template>
  <div :class="$style.keyboard">
    <div v-for="(line, index) in keySet" :class="getClassesOfLine(line)" :key="index">
      <span
        v-for="(key, keyIndex) in line.keys"
        :key="keyIndex"
        @click="e => clickKey(e, key)"
        @mousedown="mousedown"
        :style="getKeyStyle(key)"
        :class="getClassesOfKey(key)"
      >
        <img :class="$style.key__img" v-if="key.icon" :src="key.icon">
        <span v-else>{{ getCaptionOfKey(key) }}</span>
      </span>
    </div>
  </div>
</template>

<style src="vue-touch-keyboard/dist/vue-touch-keyboard.css" lang="css" />

<script type="text/babel">
// import { component as VueTouchKeyboard } from 'vue-touch-keyboard';
import layout from './layout';

const distinct = (value, index, self) => self.indexOf(value) === index;

function getCharLengthAtPos(text, { start }) {
  const charCodes = [...text];
  const charIndex = charCodes.findIndex(char => char.includes(text.substring(start, start - 1)));
  return charCodes[charIndex].length;
}

export default {
  inheritAttrs: false,
  props: {
    input: [HTMLInputElement, HTMLTextAreaElement],
    accept: Function,
    cancel: Function,
    change: Function,
    next: Function,
    defaultKeySet: {
      type: String,
      default: 'default',
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    // VueTouchKeyboard,
  },
  data() {
    return {
      currentKeySet: this.defaultKeySet,
      inputScrollLeft: 0,
    };
  },
  computed: {
    keySet() {
      const keySet = layout[this.currentKeySet];
      const meta = layout.meta || {};

      return keySet.map((line) => {
        const { keyMap = line, classes } = line;
        const keys = keyMap.split(' ')
          .map((item) => {
            if (item instanceof Object) {
              return item;
            }
            if (item.length > 2 && item[0] === '{' && item[item.length - 1] === '}') {
              const name = item.substring(1, item.length - 1);
              if (meta[name]) {
                return meta[name];
              }
              if (name == parseInt(name, 10)) {
                return {
                  placeholder: true,
                  classes: 'placeholder',
                  width: name,
                };
              }
              console.warn(`Missing named key from meta: ${name}`);
            } else {
              if (item === '') {
                return {
                  placeholder: true,
                  classes: 'placeholder',
                };
              }
              return {
                key: item,
                text: item,
              };
            }
            return null;
          });
        return {
          keys,
          ...(classes ? { classes } : {}),
        };
      });
    },
  },
  methods: {
    changeKeySet(name) {
      if (layout[name] != null) {
        this.currentKeySet = name;
      }
    },
    toggleKeySet(name) {
      this.currentKeySet = this.currentKeySet === name ? 'default' : name;
    },
    getCaptionOfKey(key) {
      return key.text || key.key || '';
    },
    getClassesOfLine(line) {
      return [
        'line',
        ...((line.classes) ? line.classes.split(' ') : []),
      ].map(cssClass => this.$style[cssClass]).filter(distinct);
    },
    getClassesOfKey(key) {
      if (key.placeholder) {
        return this.$style.placeholder;
      }
      const isActive = key.keySet && this.currentKeySet === key.keySet;

      return [
        'key',
        key.func,
        ...((key.classes) ? key.classes.split(' ') : []),
        ...(isActive ? ['activated'] : []),
      ].map(cssClass => this.$style[cssClass]).filter(distinct);
    },
    getKeyStyle(key) {
      return key.width ? {
        flex: key.width,
      } : null;
    },
    supportsSelection() {
      return (/text|password|search|tel|url/).test(this.input.type);
    },
    getCaret() {
      if (this.supportsSelection()) {
        const pos = {
          start: this.input.selectionStart || 0,
          end: this.input.selectionEnd || 0,
        };

        if (pos.end < pos.start) {
          pos.end = pos.start;
        }
        return pos;
      }
      const val = this.input.value;
      return {
        start: val.length,
        end: val.length,
      };
    },
    backspace(caret, text) {
      let resultText;
      if (caret.start < caret.end) {
        resultText = text.substring(0, caret.start) + text.substring(caret.end);
      } else {
        const offset = getCharLengthAtPos(text, caret);
        if (text.length > caret.start) {
          resultText = text.substring(0, caret.start - offset);
          resultText += text.substring(caret.start);
        } else {
          resultText = text.substring(0, caret.start - offset) + text.substring(caret.start);
        }
        caret.start = Math.max(0, caret.start - offset);
      }
      caret.end = caret.start;
      return resultText;
    },
    insertChar(caret, text, ch) {
      if (caret.start < caret.end) {
        text = text.substring(0, caret.start)  + ch.toString() + text.substring(caret.end);
      } else {
        text = text.substr(0, caret.start) + ch.toString() + text.substr(caret.start);
      }
      caret.start += ch.length;
      caret.end = caret.start;
      return text;
    },
    mousedown(e) {
      if (!this.input) return;
      if (this.options.preventClickEvent) e.preventDefault();
      this.inputScrollLeft = this.input.scrollLeft;
    },
    clickKey(e, key) {
      if (!this.input) return;
      if (this.options.preventClickEvent) e.preventDefault();
      const caret = this.getCaret();
      let text = this.input.value;

      let addChar = null;
      if (typeof key === 'object') {
        if (key.keySet) {
          this.toggleKeySet(key.keySet);
        } else if (key.func) {
          switch (key.func) {
            case 'backspace': {
              text = this.backspace(caret, text);
              break;
            }
            case 'accept': {
              if (this.accept) this.accept(text);
              return;
            }
            case 'cancel': {
              if (this.cancel) this.cancel();
              return;
            }
            case 'next': {
              if (this.next) this.next();
              return;
            }
            default: {
              this.$emit(key.func);
            }
          }
        } else {
          addChar = key.key;
        }
      } else {
        addChar = key;
      }
      if (addChar) {
        if (this.input.maxLength <= 0 || text.length < this.input.maxLength) {
          if (this.options.useKbEvents) {
            const event = document.createEvent('Event');
            event.initEvent('keydown', true, true);
            event.which = addChar.charCodeAt();
            event.keyCode = event.which;
            if (this.input.dispatchEvent(event)) {
              text = this.insertChar(caret, text, addChar);
            }
          } else {
            text = this.insertChar(caret, text, addChar);
          }
        }
        if (['shifted', 'emoji'].includes(this.currentKeySet)) {
          this.changeKeySet('default');
        }
      }
      this.input.value = text;
      this.setFocusToInput(caret);
      if (this.change) {
        this.change(text, addChar);
      }
      if (this.input.maxLength > 0 && text.length >= this.input.maxLength) {
        // The value reached the maxLength
        if (this.next) {
          this.next();
        }
      }
      // trigger 'input' Event
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    },
    setFocusToInput(caret) {
      this.input.focus();
      if (caret && this.supportsSelection()) {
        this.input.selectionStart = caret.start;
        this.input.selectionEnd = caret.end;
      }
    },
    mounted() {
      if (this.input) {
        this.setFocusToInput();
      }
    },
  },
};
</script>

<style lang="scss" module>
  $width: 40;
  $height: 2.2em;
  $margin: 0.5em;
  $radius: 0.35em;
  $bg: #ebebeb;

  .keyboard {
    position: absolute;
    bottom: 0;
    width: 100vmin;
    padding: 1rem;
    box-sizing: border-box;
    margin: 0;
    background: $bg;
    border-radius: 1em 1em 0 0;
    overflow: hidden;
  }
  .line {
    display: flex;
    justify-content: space-around;
    &:not(:last-child) {
      margin-bottom: $margin;
    }
  }
  .num {
    background: #0001;
    padding: 1rem;
    font-size: 1rem;
    margin: -1rem;
  }

  .placeholder {
    flex-grow: 15;
    &:not(:last-child) {
      margin-right: $margin;
    }
  }

  .key {
    &:not(:last-child) {
      margin-right: $margin;
    }
    flex: $width;
    //width: $btnW;
    height: $height;
    line-height: $height;
    overflow: hidden;
    vertical-align: middle;
    color: #333;
    background-color: $bg;
    box-shadow: -4px -4px 10px rgba(#fff, .6), 4px 4px 10px rgba(#000, .2);
    border-radius: $radius;
    font-size: 1.25em;
    text-align: center;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &.backspace {
      // background-image: url("./icons/backspace.svg");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 35%;
    }

    &__img {
      width: 2em;
    }

    &.half {
      flex: $width / 2;
    }
    &.control {
      color: #fff;
      background-color: #d5cfd0;
      border-color: #656565;
    }

    &.featured {
      color: #fff;
      background-color: #337ab7;
      border-color: #2e6da4;
    }
    &:hover {
      color: #333;
      background-color: #d6d6d6;
      border-color: #adadad;
    }

    &:active {
      transform: scale(.98); // translateY(1px);
      color: #333;
      background-color: #ffffff;
      border-color: #8c8c8c;
    }
    &.activated {
      box-shadow: 0 0 4px #09d9ff;
    }
  }
</style>
